import { Button, Icon, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, EmptySection } from '@hero/atoms';

import * as S from './style';

function AutomationWordCloud() {
  const { t } = useTranslation();

  return (
    <Card style={{ gap: 16, flex: 1 }}>
      <S.CardHeader>
        <Typography variant="body1Bold">{t('wordCloud')}</Typography>
        <VerticalDivider />
        <Button variant="link" startIcon={<Icon name="refresh" />}>
          {t('refresh')}
        </Button>
      </S.CardHeader>
      <EmptySection title={t('wordCloudEmptyText')} />
    </Card>
  );
}

export { AutomationWordCloud };
